import { useCallback, useEffect, useState } from 'react';
import { organizationsApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { DataTable, type Column } from '@/components/ui/DataTable';
import { dataTablePageProps, usePagination } from '@/hooks/usePagination';
import type { OrganizationResponse } from '@/types/organization';
import { showApiError } from '@/utils/apiError';

export function SubscriptionsPage() {
  const pagination = usePagination();
  const [data, setData] = useState<OrganizationResponse[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await organizationsApi.list({
        page: pagination.page,
        size: pagination.size,
        activeOnly: false,
      });
      setData(res.content);
      pagination.applyPageResponse(res);
    } catch (err) {
      showApiError(err, 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, [pagination.page, pagination.size, pagination]);

  useEffect(() => {
    void load();
  }, [load]);

  const columns: Column<OrganizationResponse>[] = [
    { key: 'name', header: 'Organization' },
    { key: 'subscriptionPlan', header: 'Plan' },
    { key: 'subscriptionStatus', header: 'Status' },
    { key: 'email', header: 'Contact' },
  ];

  return (
    <div>
      <PageHeader
        title="Subscriptions"
        description="Organization subscription status across the platform"
        breadcrumbs={[{ label: 'Master', to: '/master' }, { label: 'Subscriptions' }]}
      />
      <DataTable
        columns={columns}
        data={data}
        keyField="id"
        loading={loading}
        {...dataTablePageProps(pagination)}
      />
    </div>
  );
}
